import { render } from "./RegistrationUploadAvatar.vue?vue&type=template&id=107bd08a&scoped=true"
import script from "./RegistrationUploadAvatar.vue?vue&type=script&lang=js"
export * from "./RegistrationUploadAvatar.vue?vue&type=script&lang=js"

import "@/Common/Styles/registrationSteps.scss?vue&type=style&index=0&id=107bd08a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-107bd08a"]])

export default __exports__